export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9800.be35e11c.jpg";